module.exports = __webpack_public_path__ + "img/8.766bdfc6.png";